import api from '../httpClient';
import type { ToolkitNote } from '../../types';

export const toolkit = {
  listNotes: (params?: { search?: string; include_deleted?: boolean }) =>
    api.get<ToolkitNote[]>('/api/toolkit/notes/', { params }),
  createNote: (
    payload: Partial<Pick<ToolkitNote, 'title' | 'body' | 'source_flow' | 'source_flow_name'>> = {},
  ) => api.post<ToolkitNote>('/api/toolkit/notes/', payload),
  updateNote: (
    id: string,
    payload: Partial<Pick<ToolkitNote, 'title' | 'body' | 'source_flow' | 'source_flow_name'>>,
  ) => api.patch<ToolkitNote>(`/api/toolkit/notes/${id}/`, payload),
  deleteNote: (id: string) => api.delete(`/api/toolkit/notes/${id}/`),
  recordSession: (id: string, payload: { duration_seconds: number; ended_at?: string }) =>
    api.post<ToolkitNote>(`/api/toolkit/notes/${id}/session/`, payload),
};
